import { Button, Pagination, Tabs } from '@roo/roo';
import { Col, Row } from '@roo/roo/Grid';
import * as React from 'react';
import { ICategoryItem, getServiceList, ISubCategoryItem } from './api';
import './index.scss';
import ListTable from './components/list';

const { useState, useEffect } = React;
const { Pane: TabPane } = Tabs;

const Index = () => {
    const [serviceList, setServiceList] = useState<ICategoryItem[]>([]);
    const [currentTab, setCurrentTab] = useState<string>('0');
    const [currentPage, setCurrentPage] = useState<number>(1);
    const [categoryId, setCategoryId] = useState<number>(0);
    const [tableLoading, setTableLoading] = useState<boolean>(false);

    /** 高亮激活的二级分类ID */
    const [activeSubCategoryId, setActiveSubCategoryId] = useState<number>(-999);
    /** 每页数据大小 */
    const pageSize = 10;
    /** 二级分类“全部”的ID值 */
    const defaultActiveSubCategoryId = -999;
    /** 无二级分类时的二级分类ID */
    const nullSubCategoryId = -1;

    useEffect(() => {
        initServiceList();
    }, []);

    useEffect(() => {
        const id = serviceList.length > 0 ? serviceList[parseInt(currentTab, 10)].categoryID : 0;
        setCategoryId(id);
    }, [currentTab, serviceList]);

    const initServiceList = () => {
        setTableLoading(true);
        getServiceList()
            .then(res => {
                setServiceList(res.data || []);
                if (parseInt(currentTab, 10) > res.data.length) {
                    setCurrentTab('0');
                }
            })
            .catch(() => {})
            .finally(() => {
                setTableLoading(false);
            });
    };

    // 一级列表tab切换，name为对应的idx
    const handleTabClick = (name: string) => {
        setCurrentTab(name);
        setActiveSubCategoryId(defaultActiveSubCategoryId);
        setCurrentPage(1);
    };

    // 二级列表tag点击事件
    const handleSubCategoryItemClick = (categoryID: number) => {
        setCurrentPage(1);
        setActiveSubCategoryId(categoryID);
    };

    /**
     * 根据一级分类拿对应的二级分类
     * @param categoryID 一级分类id
     * @returns 二级分类列表
     */
    const getSubCategoryList = (categoryID: number) => {
        const serviceCategory = serviceList.filter(c => c.categoryID === categoryID)[0];
        if (!serviceCategory) return [];
        const subCategoryList: ISubCategoryItem[] = [];
        serviceCategory.serviceList
            .map(s => s.subCategory)
            .forEach(sub => {
                if (!subCategoryList.some(s => s.categoryID === sub.categoryID)) {
                    subCategoryList.push(sub);
                }
            });
        return subCategoryList;
    };

    /**
     * 根据一级分类和对应的二级tag筛选对应的服务列表
     * @param categoryId 一级分类id
     * @returns 筛选之后的服务列表
     */
    const getFilterServiceList = (categoryId: number) => {
        // 过滤一级分类ID
        const category = serviceList.filter(c => c.categoryID === categoryId)[0];
        if (!category) return [];
        let arr = category.serviceList;
        // 过滤二级分类ID
        if (activeSubCategoryId !== defaultActiveSubCategoryId) {
            arr = arr.filter(s => s.subCategory.categoryID === activeSubCategoryId);
        }
        return arr;
    };

    /**
     * 获取分页后的服务列表，分页前端处理
     * @param categoryId 一级列表id
     * @returns 分页后的服务列表
     */
    const getPageServiceList = (categoryId: number) => {
        let arr = getFilterServiceList(categoryId);
        // 计算分页数据
        arr = arr.slice((currentPage - 1) * pageSize, currentPage * pageSize);
        return arr;
    };

    // 二级列表的展示
    const renderSubCategoryList = () => {
        if (serviceList.length < 1) return null;
        const arr = getSubCategoryList(categoryId);
        if (!(arr.length === 1 && arr[0].categoryID === nullSubCategoryId)) {
            return (
                <div className="sub-category-list">
                    <div
                        className={`sub-category ${
                            activeSubCategoryId === defaultActiveSubCategoryId ? 'active' : ''
                        }`}
                        onClick={() => {
                            handleSubCategoryItemClick(defaultActiveSubCategoryId);
                        }}
                    >
                        全部
                    </div>
                    {arr.map(e => (
                        <div
                            className={`sub-category ${
                                activeSubCategoryId === e.categoryID ? 'active' : ''
                            }`}
                            onClick={() => {
                                handleSubCategoryItemClick(e.categoryID);
                            }}
                        >
                            {e.categoryName}
                        </div>
                    ))}
                </div>
            );
        }
        return null;
    };

    const handlePageChange = (page: number) => {
        setCurrentPage(page);
    };

    const addNewService = () => {
        window.location.hash = '/main/v3/add';
    };

    return (
        <div className="service-list-content">
            <h1>
                <Row>
                    <Col span={10}>服务管理</Col>
                    <Col span={2}>
                        <Button onClick={addNewService}>新增服务</Button>
                    </Col>
                </Row>
            </h1>
            <div>
                <Tabs type="line" value={currentTab} onTabClick={handleTabClick}>
                    {serviceList.map((e, idx) => (
                        <TabPane label={e.categoryName} name={idx.toString()} />
                    ))}
                </Tabs>
            </div>
            <div>{renderSubCategoryList()}</div>
            <div className="service-list-table">
                <ListTable
                    list={getPageServiceList(categoryId)}
                    refresh={initServiceList}
                    tableLoading={tableLoading}
                />
            </div>
            {getFilterServiceList(categoryId).length > pageSize ? (
                <div className="pagination">
                    <Pagination
                        total={getFilterServiceList(categoryId).length}
                        currentPage={currentPage}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                    />
                </div>
            ) : null}
            <div />
        </div>
    );
};

export default Index;
